import { Button } from "@mantine/core";
import { useNavigate } from "react-router-dom";

export function WarrantyRegistration() {
  const navigate = useNavigate();

  function handleClick() {
    navigate("warranty-registration");
  }

  return (
    <Button variant="outline" onClick={handleClick}>
      Warranty Registration
    </Button>
  );
}
